<template>
  <div class="crud_module--rsr_cancel_charger">
    <el-button type="info" @click="upload()">
      <fa v-if="field?.param?.label == 'arrow-up'" :icon="['fas', 'arrow-up']"/>
      <fa v-if="field?.param?.label == 'dollar-sign'" :icon="['fas', 'dollar-sign']"/>
      <fa v-else :icon="['fas', 'edit']"/>
    </el-button>
  </div>
</template>

<script>
export default {
  props: ["data","field"],
  components: {
  },
  async beforeMount() {},
  methods: {
    async upload () {
      let action = this.$t("button.edit");
      let message = this.$t("message.confirm_start_charger", {action : action});
      if(this.field?.param?.msg) message = this.field?.param?.msg;
      let confirm = await this.$confirm(message, message, {
        confirmButtonText: action,
        cancelButtonText: "取消",
        type: "warning",
      });
      if (!confirm) return;

      let param = {};
      for(let i in this.field.param.post_key){
        let row = this.field.param.post_key[i];
        let rowKey=(row.rowKey?row.rowKey:row.key);
        let postKey=row.key;

        param[postKey]=this.data[rowKey];
      }
      
      console.log("param",param);
      await this.$axios.post(this.field.param.url, param).then(res=>{
        console.log("res",res);
        if(res.data?.status == "success"){
          this.$message({
            message: this.$t("success"),
            type: 'success'
          });
          this.$emit("needUpdate");
        }
        else if(res.data?.status == "error"){
          this.$message({
            message: this.$t(`error.${res.data?.errorCode}`),
            type: 'error'
          });
        }
        else {
          this.$message({
            message: this.$t("error.generic"),
            type: 'error'
          });
        }
      }).catch(err=>{
        this.$message({
            message: this.$t("error.generic"),
            type: 'error'
        });
        return false;
      });
    }
  },
  data() {
    return {
      key: "",
      id:0,
      loading:false,
      connectors:[],
      input:{
        connectorId:0,
        duration:0,
        startCode:"",
        lp:"",
        entryTime:""
      },
    }
  }
}
</script>